import { Component, OnInit } from '@angular/core';
import { PageMixin } from 'src/app/services/mixins/page.mixin';
import { PageService } from 'src/app/services/page.service';
import { Title, Meta } from '@angular/platform-browser';
import { InfoService } from 'src/app/services/info.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { BaseComponent } from '../../base.component';
import { ClientService } from '../../../services/client.service';
import { LangService } from '../../../services/lang.service';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
})
export class PrivacyComponent extends PageMixin(BaseComponent) implements OnInit {
    public constructor(
        public page: PageService,
        protected translate: TranslateService,
        protected client: ClientService,
        protected lang: LangService,
        protected title?: Title,
        protected meta?: Meta,
        protected route?: Router,
        protected info?: InfoService,
    ) {
        super(page, title, meta, route, info);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.page.setPageTitle('web.privacy_cookies');
        this.lang.getLang().then((): Promise<any> => this.createTitle());
    }

    /**
     * Create page title and meta
     * @return Promise<any>
     */
    private createTitle(): any {
        this.translate.get('web.title_privacy').subscribe((): void => {
            const trans = this.translate.instant('web.title_privacy');
            const client = this.client.getVName();
            this.setTitle(
                {
                    title: `${trans} | ${client}`,
                    description: this.translate.instant('web.description_privacy'),
                },
                true,
            );
        });
    }
}
